import StoreHeader from "../../components/layout/StoreHeader";
import StoreFooter from "../../components/layout/StoreFooter";
import { useSettings } from "../../context/SettingsContext";
import { Truck } from "lucide-react";

const DEFAULT_TEXT = `We dispatch most orders the same day if placed before 2pm AEST, Monday to Saturday.

Standard delivery within Brisbane metro typically takes 1-2 business days. Regional Queensland and interstate delivery typically takes 3-7 business days depending on location.

Shipping costs are calculated at checkout based on the size and weight of your order. Free shipping applies on eligible orders over the threshold shown in your cart.

Large or bulky items (engines, gearboxes, body panels) may require freight quoting — our team will contact you directly if this applies to your order.

For questions about a specific order's shipping status, please contact us with your order number.`;

export default function ShippingPolicy() {
  const { settings } = useSettings();
  const text = settings.shipping_policy?.trim() || DEFAULT_TEXT;

  return (
    <div className="bg-white min-h-screen">
      <StoreHeader />

      <div className="bg-[#0b1a3b] py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-[#e31e24] font-mono text-[11px] uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <Truck className="h-3.5 w-3.5" /> Customer support
          </div>
          <h1 className="font-heading text-[44px] font-black uppercase text-white leading-tight">
            Shipping Policy
          </h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <div className="prose prose-zinc max-w-none whitespace-pre-line text-[15px] leading-relaxed text-zinc-700">
          {text}
        </div>
      </div>

      <StoreFooter />
    </div>
  );
}
